import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  return <section className="relative w-full px-6 pt-20 pb-24 md:pt-32 md:pb-32 overflow-hidden" data-id="element-64">
      <div className="max-w-3xl mx-auto text-center" data-id="element-65">
        <motion.span initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="inline-block text-terracotta font-medium tracking-widest text-sm uppercase mb-6" data-id="element-66">
          The 21-Day Protocol
        </motion.span>

        <motion.h1 initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="font-serif text-4xl md:text-6xl lg:text-7xl text-stone-800 leading-[1.1] mb-10" data-id="element-67">
          Your Belly Is Not a <br className="hidden md:block" data-id="element-68" />
          <span className="italic" data-id="element-69">Motivation Problem</span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="space-y-6 text-lg md:text-xl text-stone-600 leading-relaxed max-w-2xl mx-auto text-left md:text-center" data-id="element-70">
          <p data-id="element-71">By afternoon, your belly feels like it belongs to someone else.</p>
          <p data-id="element-72">
            Morning you is hopeful. You put on jeans and they are fine. Then the
            day happens. Stress. Coffee. Random meals. Sitting. Running around.
            Not drinking enough water. Not sleeping enough the night before.
          </p>
          <p data-id="element-73">
            And at some point, you look down and think, why do I look pregnant.
          </p>
          <p className="font-serif text-2xl text-stone-800 italic pt-4 pb-2" data-id="element-74">
            Because you are pulling on a door with four locks.
          </p>
          <p data-id="element-75">
            This is the 21 day plan that shows you exactly where the locks are,
            and how to open them. Without calorie counting. Without punishing
            workouts. Without starting over every Monday.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="mt-12 mb-12" data-id="element-76">
          <img src="https://cdn.magicpatterns.com/uploads/gnUDfcn1Brw8kVEQFv5pr9/N1PIC1.png" alt="The 21 Day Perimenopause Belly Reset on tablet and phone" className="w-full max-w-2xl mx-auto rounded-lg shadow-xl" data-id="element-77" />
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} data-id="element-78">
          <a href="#offer" className="inline-flex items-center justify-center px-8 py-4 bg-terracotta text-white text-lg font-medium rounded-full hover:bg-terracotta-dark transition-all duration-300 hover:scale-[1.02] shadow-lg shadow-terracotta/20" data-id="element-79">
            Get the 21-Day Reset
            <ArrowRight className="ml-2 h-5 w-5" data-id="element-80" />
          </a>
        </motion.div>
      </div>
    </section>;
}